import requestGeo from '../utils/requestGeo'
export function queryFeatrue(params) {
  return requestGeo({
    url: '/geoserver/wms',
    method: 'get',
    params
  })
}

